import React from 'react';
import {Label} from './styles';

export default ({
  text,
  color = '#5d6c76',
  decoration = 'none',
  cursor = 'default',
  callback,
  fontWeight = '400',
  fontSize = '15px',
}: {
  text: string;
  color?: string;
  decoration?: string;
  cursor?: string;
  callback?: any;
  fontWeight?: string;
  fontSize?: string;
}) => (
  <Label color={color} decoration={decoration} cursor={cursor} onClick={callback} fontWeight={fontWeight} fontSize={fontSize}>
    {text}
  </Label>
);
